"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clearTimeout = exports.setTimeout = void 0;
var getZoneJsOriginalValue_1 = require("../tools/getZoneJsOriginalValue");
var monitor_1 = require("../tools/monitor");
function setTimeout(callback, delay) {
    return (0, getZoneJsOriginalValue_1.getZoneJsOriginalValue)(window, 'setTimeout')((0, monitor_1.monitor)(callback), delay);
}
exports.setTimeout = setTimeout;
function clearTimeout(timeoutId) {
    (0, getZoneJsOriginalValue_1.getZoneJsOriginalValue)(window, 'clearTimeout')(timeoutId);
}
exports.clearTimeout = clearTimeout;
//# sourceMappingURL=timer.js.map